import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAppSelector } from "../../hooks/useAppSelector";

/**
 * The query cache belongs to whoever is signed in. Most query keys do not carry the user
 * (`['pending-acknowledgments']`, …), so after «cambiar de usuario» the screens kept showing the
 * previous user's data until a reload. When the signed-in user changes, the cache is dropped and
 * every screen asks again as the new user.
 */
export function ClearCacheOnUserChange(): null {
  const uid = useAppSelector((state) => state.authReducer.user?.uid);
  const queryClient = useQueryClient();
  const previousUid = useRef(uid);

  useEffect(() => {
    if (previousUid.current && uid && previousUid.current !== uid) queryClient.clear();
    previousUid.current = uid;
  }, [uid, queryClient]);

  return null;
}
